export enum SidebarId {
  AboutPermissions = 'about-permissions-sidebar',
  SsoConfiguration = 'sso-configuration-sidebar',
  AccountDetails = 'account-details-sidebar',
  UserDetails = 'user-details-sidebar',
  PaymentMethodDetails = 'payment-method-sidebar',
  TwoFactorAuth = 'two-factor-auth-sidebar',
  // TODO: Remove once all angular sidebars are migrated to React
  AngularPortal = 'angular-sidebar-portal',
  UserPermissions = 'user-permissions-sidebar',
}
